import { Route } from 'src/routes/Route'

export const MyCampaignsRoute = Route({
  path: 'my-campaigns',
})

export type MyCampaignsRoute = Route<typeof MyCampaignsRoute>
